import type { RouteRecordRaw } from "vue-router"

/**
 * Routes PV déclarées sous la fiche bâtiment dans {@link @core/router/building.routes.ts}.
 */
export const routes = [] as RouteRecordRaw[]
